<template>
  <div class="box">
    <!-- 顶部轮播图（纯原生、无报错、不影响任何其他代码） -->
    <div class="carousel-box">
      <div class="slide" v-for="(item, idx) in carouselImgs" :key="idx" :style="{
        opacity: current === idx ? 1 : 0,
        zIndex: current === idx ? 10 : 1,
        backgroundImage: `url(${item.img})`
      }">
        <!-- 只有当 showText 为 true 时才显示文字 -->
        <div v-if="item.showText" class="banner_title">工作无边界</div>
        <div v-if="item.showText" class="banner_content">数字游民人才共享 • 为新一代自由职业者提供一站式解决方案</div>
      </div>
    </div>

    <div class="content-box">
      <div class="content">
        <div class="content_title">最新需求</div>
        <div class="require_list">
          <el-row :gutter="19">
            <el-col :span="8" v-for="(item, index) in requireList.slice(0, 6)" :key="index">
              <div class=" grid-content bg-purple">
                <div class="require_item" @click="gotoDemand(item)">
                  <div class="top1">{{ item.title }}</div>
                  <div class="top2">{{ item.nickname }}</div>
                  <div class="line"></div>
                  <div class="bottom1">
                    <div>进行中</div>
                    <div>人数需求：{{ item.number }}人</div>
                  </div>
                  <div class="bottom2">
                    <div>数量：1</div>
                    <div>￥{{ item.price }}</div>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>

          <div class="more" @click="goMore">查看更多&nbsp;></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { information_listApi } from "../api/index";

export default {
  data() {
    return {
      requireList: [],
      dialogVisible: false,
      index: 1,
      BottomCurrentIndex: 0,
      windowWidth: document.documentElement.clientWidth,

      // 轮播图（安全无报错版本）
      carouselImgs: [
        {
          img: require("../assets/lunbo/homeBanner.png"),
          showText: true // 显示文字
        },
        {
          img: require("../assets/car.png"),
          showText: false // 不显示文字
        }
      ],
      current: 0,
      timer: null
    };
  },
  created() {
    window.scrollTo(0, 0);
    this.getPublishRequire();
    this.startPlay();
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    // 轮播自动播放
    startPlay() {
      this.timer = setInterval(() => {
        this.current = (this.current + 1) % this.carouselImgs.length;
      }, 3000);
    },

    gotoDemand(value) {
      this.$router.push({
        path: "/demandInfo",
        query: {
          date: value.id
        }
      });
    },
    goMore() {
      this.$router.push("/display");
    },
    async getPublishRequire() {
      const res = await information_listApi(this.params);
      if (res.data.code === 1) {
        this.requireList = res.data.data;
      }
    },
    bottomBtn(index) {
      this.BottomCurrentIndex = index;
    },
    leftPlayIconBtn() {
      console.log(11);
      this.mutedOneShow = true;
      this.$refs.videoOne.play();
    },
    topPlayIconBtn() {
      this.mutedTwoShow = true;
      this.$refs.videoTwo.play();
    },
    bottomPlayIconBtn() {
      this.mutedThreeShow = true;
      this.$refs.videoThree.play();
    },
    contactBtn() {
      this.$router.push("/contact");
    },
    downFn(item) {
      console.log(item);
      if (item.title !== "火星计划") {
        this.$message({
          showClose: true,
          message: "敬请期待",
          offset: 50,
          duration: 1000
        });
      } else {
        window.open("https://www.taptap.cn/app/378080", "_blank");
      }
    },
    close() {
      this.dialogVisible = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.box {
  padding: 75px 0 0 0;
}

.display .imgbox {
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;

  .image {
    width: 200px;
    height: 200px;

    .img {
      width: 100%;
      height: 100%;
    }
  }
}

img {
  width: 100%;
  height: 100%;
}

/* 轮播图样式（不影响任何原有样式） */
.carousel-box {
  margin: 0 auto;
  height: 450px;
  width: 1200px;
  position: relative;
  color: #fff;
  overflow: hidden;

  .slide {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    transition: opacity 0.8s ease;
  }

  .banner_title {
    font-size: 75px;
  }

  .banner_content {
    font-size: 35px;
    margin-top: 23px;
  }
}

.content-box {
  width: 100%;
  margin-bottom: 100px;

  .content {
    .content_title {
      font-weight: bold;
      font-size: 38px;
      color: #3669FF;
      text-align: center;
      position: relative;
      margin: 78px 0 74px 0;

      &::after {
        content: "";
        display: block;
        position: absolute;
        width: 70px;
        height: 4px;
        left: 50%;
        transform: translateX(-50%);
        background-color: #3669FF;
      }
    }

    .require_list {
      width: 1200px;
      margin: 0 auto;

      .require_item {
        background-color: #ffffff;
        box-sizing: border-box;
        padding: 21px 0px 12px 0px;
        display: flex;
        flex-direction: column;
        align-items: center;
        cursor: pointer;

        .top1 {
          padding: 3px 20px;
          background-color: #d1dcff;
          font-size: 20px;
          color: #3669FF;
          font-weight: bold;
          text-align: center;
          line-height: 39px;
        }

        .top2 {
          width: 220px;
          font-size: 15px;
          color: #000000;
          margin: 16px 0 0 0;
          height: 45px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          text-indent: 2em;
        }

        .line {
          width: 234px;
          height: 1px;
          background-color: #B9B9B9;
          margin: 23px 0;
        }

        .bottom1 {
          display: flex;
          justify-content: space-between;
          width: 234px;

          div:nth-child(1) {
            width: 51px;
            height: 26px;
            background-color: #D1FFD6;
            font-size: 12px;
            color: #3DC26E;
            text-align: center;
            line-height: 26px;
            border-radius: 15px;
          }

          div:nth-child(2) {
            font-size: 12px;
          }
        }

        .bottom2 {
          width: 234px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 11px;

          div:nth-child(1) {
            font-size: 12px;
            color: #A2A2A2;
          }

          div:nth-child(2) {
            font-size: 20px;
            color: #FF2A2A;
          }
        }
      }

      .el-row {
        margin-bottom: 20px;

        &:last-child {
          margin-bottom: 0;
        }
      }

      .el-col {
        border-radius: 4px;
        margin-bottom: 20px;
      }

      .bg-purple {}

      .grid-content {
        border-radius: 4px;
        min-height: 36px;
      }
    }

    .more {
      width: 131px;
      height: 36px;
      font-size: 18px;
      color: #FFFFFF;
      text-align: center;
      line-height: 36px;
      background-color: #3669ff;
      margin: 0 auto;
      margin-top: 50px;
      cursor: pointer;
    }
  }
}
</style>